import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pay",
  "use": "icon-pay-usage",
  "viewBox": "0 0 200 60",
  "content": "<symbol viewBox=\"0 0 200 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pay\">\n  <!-- 按钮背景 -->\n  <rect x=\"0\" y=\"0\" width=\"200\" height=\"60\" rx=\"8\" fill=\"#FF6B00\" />\n\n\n  <!-- 文字 -->\n  <text x=\"100\" y=\"35\" font-family=\"Arial\" font-size=\"16\" fill=\"#FFFFFF\" text-anchor=\"middle\">立即支付</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pay.svg
// module id = bVjv
// module chunks = 50